import React, { useState } from 'react'
import { CRow, CCard } from '@coreui/react'
import { isEmpty } from 'lodash'
import PublishIcon from '../../../assets/publish-icon.svg'

const ComponentSelection = ({ data, allowedComponents, setAllowedComponents }) => {
  const [category, setCategory] = useState('all')

  const handleCategorySelect = (cat) => {
    setCategory(cat)
  }

  const handleComponentSelect = (info) => {
    let temp = allowedComponents
    if (allowedComponents.includes(info._id)) {
      temp = allowedComponents.filter((e) => e !== info._id)
    } else {
      temp.push(info._id)
    }
    setAllowedComponents([...temp])
  }

  const isDisabled = (category) => {
    let arr = data.filter((info) => info?.data?.category.includes(category))
    return isEmpty(arr)
  }
  return (
    <CCard className="rounded-0  position-relative">
      <div
        className="m-auto p-0 w-100"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          height: '70vh',
        }}
      >
        <div style={{ width: '23%', background: '#e1e1e1', color: '#171717' }} className="">
          <div className="w-100" style={{ padding: '20.7% 0px 0px 24.7%' }}>
            <p style={{ fontSize: '1.25vw' }}>ADD NEW SECTION</p>
            <div style={{ fontSize: '1.04vw' }} className="mt-5">
              <p
                style={{ fontWeight: category === 'all' ? '500' : '' }}
                className={`${
                  category === 'all' && 'selected-text-underline '
                } cursor-pointer mb-3`}
                onClick={() => handleCategorySelect('all')}
              >
                All Sections
              </p>
              <p
                style={{ fontWeight: category === 'promotion' ? '500' : '' }}
                className={`${
                  category === 'promotion' && 'selected-text-underline '
                } cursor-pointer mb-3`}
                onClick={() => handleCategorySelect('promotion')}
              >
                Ad/Promotional Space
              </p>
              <p
                style={{ fontWeight: category === 'banner_carousel' ? '500' : '' }}
                className={`${
                  category === 'banner_carousel' && 'selected-text-underline '
                } cursor-pointer mb-3`}
                onClick={() => handleCategorySelect('banner_carousel')}
              >
                Banner carousel
              </p>
              <p
                style={{ fontWeight: category === 'card_carousel' ? '500' : '' }}
                className={`${
                  category === 'card_carousel' && 'selected-text-underline '
                } cursor-pointer mb-3`}
                onClick={() => handleCategorySelect('card_carousel')}
              >
                Card Carousel
              </p>
              <p
                style={{ fontWeight: category === 'category_list' ? '500' : '' }}
                className={`${
                  category === 'category_list' && 'selected-text-underline '
                } cursor-pointer mb-3`}
                onClick={() => handleCategorySelect('category_list')}
              >
                Category List
              </p>
              <p
                style={{
                  fontWeight: category === 'footer' ? '500' : '',
                  color: isDisabled('footer') ? '#a1a1a1' : '',
                  cursor: isDisabled('footer') ? 'default' : 'pointer',
                }}
                className={`${category === 'footer' && 'selected-text-underline '} mb-3`}
                onClick={isDisabled('footer') ? null : () => handleCategorySelect('footer')}
              >
                Footer
              </p>
              <p
                style={{ fontWeight: category === 'group_carousel' ? '500' : '' }}
                className={`${
                  category === 'group_carousel' && 'selected-text-underline '
                } cursor-pointer mb-3`}
                onClick={() => handleCategorySelect('group_carousel')}
              >
                Group Carousel
              </p>
              <p
                style={{
                  fontWeight: category === 'header' ? '500' : '',
                  color: isDisabled('header') ? '#a1a1a1' : '',
                  cursor: isDisabled('header') ? 'default' : 'pointer',
                }}
                className={`${category === 'header' && 'selected-text-underline '} mb-3`}
                onClick={isDisabled('header') ? null : () => handleCategorySelect('header')}
              >
                Header
              </p>
              <p
                style={{ fontWeight: category === 'static_cards' ? '500' : '' }}
                className={`${
                  category === 'static_cards' && 'selected-text-underline '
                } cursor-pointer mb-3`}
                onClick={() => handleCategorySelect('static_cards')}
              >
                Static Cards
              </p>
              <p
                style={{ fontWeight: category === 'testimonial' ? '500' : '' }}
                className={`${
                  category === 'testimonial' && 'selected-text-underline '
                } cursor-pointer`}
                onClick={() => handleCategorySelect('testimonial')}
              >
                Testimonial
              </p>
            </div>
          </div>
        </div>
        <div style={{ width: '77%' }} className="">
          <div className="w-100 static-scrollbar-class h-100" style={{ padding: '1% 4%' }}>
            <CRow className=" w-100 flex justify-between" xs={{ cols: 2, gutterY: 5, gutterX: 0 }}>
              {data
                .filter((info) => category === 'all' || info?.data?.category.includes(category))
                .map((info, index) => (
                  <div
                    style={{ width: '45.6%' }}
                    key={index}
                    className="d-flex flex-column justify-center align-items-center"
                  >
                    <CCard
                      className="add-section-card w-100 flex justify-center items-center cursor-pointer position-relative"
                      onClick={() => handleComponentSelect(info)}
                    >
                      {allowedComponents.includes(info._id) && (
                        <img
                          src={PublishIcon}
                          className="position-absolute"
                          style={{ zIndex: 25, right: 0, top: 0 }}
                          alt="PublishIcon"
                        />
                      )}
                      <img
                        src={info?.preview_s3_key?.website}
                        style={{ maxHeight: '100%', maxWidth: '100%' }}
                        className=""
                        alt="preview_s3_key"
                      />
                    </CCard>
                    <span style={{ fontSize: '1.04vw', fontWeight: '450' }} className="mt-2">
                      {info?.component_name}
                    </span>
                  </div>
                ))}
            </CRow>
          </div>
        </div>
      </div>
    </CCard>
  )
}

export default ComponentSelection
